import angular from 'angular';
import DocumentService from '@/shared/services/DocumentService';
import { isWord, isPdf } from '@/shared/utils/mime';

angular
  .module('cxTaskflow')
  .controller('MailEmailDomainCnameInfoDialogCtrl', [
    '$scope',
    '$element',
    '$timeout',
    '$translate',
    '$q',
    '$filter',
    'templateHttpSvc',
    'resourceFactorySvc',
    'flySvc',
    '$http',
    'appUrls',
    'dialogsSvc',
    'close',
    'companyId',
    mailEmailDomainCnameInfoDialogCtrl,
  ]);

function mailEmailDomainCnameInfoDialogCtrl(
  $scope,
  $element,
  $timeout,
  $translate,
  $q,
  $filter,
  templateHttpSvc,
  resourceFactorySvc,
  flySvc,
  $http,
  appUrls,
  dialogsSvc,
  close,
  companyId,
) {
  var vm = this;
  vm.sending = false;
  vm.email = {};
  vm.showValidation = false;
  vm.addresses = [];
  vm.sendTo = [];
  vm.cc = [];
  vm.bcc = [];

  var showError = function(error) {
    vm.sending = false;
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.refreshPreview = function() {
    vm.preview = null;
    vm.previewError = null;

    $http
      .get(appUrls.api + '/api/settings/GetEmailDomainInfoMail?id=' + companyId)
      .then(function(response) {
        var result = response.data;
        if (result) {
          vm.preview = result;
          if (vm.preview.body === null && vm.preview.subject === null) {
            flySvc.message('msgTemplateNotInLanguage');
          }

          if (vm.preview.cc && vm.preview.cc.length && (!vm.cc.length || !vm.cc[0])) {
            vm.cc = vm.preview.cc;
          }
          vm.addToAddress();
        }
      })
      .catch(function(error) {
        vm.previewError = flySvc.getErrorMsg(error);
        flySvc.error(error);
      });
  };
  vm.refreshPreview();

  vm.addToAddress = function() {
    vm.sendTo.push('');
    $timeout(function() {
      $element
        .find('.form-group .row.email .dropdown input[type="text"]')
        .filter(':visible')
        .last()
        .focus();
    }, 200);
  };
  vm.addCcAddress = function() {
    vm.cc.push('');
    $timeout(function() {
      $element
        .find('.form-group .row.cc .dropdown input[type="text"]')
        .filter(':visible')
        .last()
        .focus();
    }, 200);
  };

  vm.addBccAddress = function() {
    vm.bcc.push('');
    $timeout(function() {
      $element
        .find('.form-group .row.bcc .dropdown input[type="text"]')
        .filter(':visible')
        .last()
        .focus();
    }, 200);
  };
  vm.validateEmail = function(value, emptyValid) {
    if (!value && emptyValid) return true;
    return /^[^@]+@.+\..+$/.test(value);
  };

  vm.validate = function() {
    if (!vm.preview || !vm.preview.subject || !vm.preview.body) return false;

    for (var j = 0; j < vm.sendTo.length; j++) {
      if (!vm.validateEmail(vm.sendTo[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    for (var j = 0; j < vm.cc.length; j++) {
      if (!vm.validateEmail(vm.cc[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    for (var j = 0; j < vm.bcc.length; j++) {
      if (!vm.validateEmail(vm.bcc[j], false)) {
        flySvc.error('msgInvalidEmailAddress');
        return false;
      }
    }
    return true;
  };

  vm.save = function() {
    if ($scope.form.$invalid || vm.sending) return;
    if (!vm.validate()) return;
    vm.sending = true;
    vm.preview.cc = vm.cc;
    vm.preview.bcc = vm.bcc;
    vm.preview.to = vm.sendTo;
    vm.preview.recipients = vm.sendTo;

    $http.post(appUrls.api + '/api/settings/SendEmailDomainInfoMail', vm.preview).then(function() {
      vm.sending = false;
      flySvc.success('EmailSent');
      $element.modal('hide');
    }, showError);
  };

  vm.cancel = function() {
    close(false, 500);
  };
}
